import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { learnArticles } from '../data/learnContent';
import { LOGO_DARK } from '../config';
import BottomNavBar from './BottomNavBar';

const LearnTab = () => {
  const [activeArticle, setActiveArticle] = useState(null);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 pb-24">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-30">
        <div className="max-w-3xl mx-auto px-4 py-4">
          <div className="flex items-center space-x-3">
            <img src={LOGO_DARK} alt="Daily Discipline" className="h-8 w-8" />
            <span className="text-lg font-bold text-gray-900">Daily Discipline™</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="p-4 max-w-3xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Library</h1>
          <p className="text-gray-500">Master the psychology of habit building.</p>
        </div>

        {/* Article List */}
        <div className="space-y-4">
          {learnArticles.map((article) => (
            <div
              key={article.id}
              onClick={() => setActiveArticle(article)}
              className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100 cursor-pointer hover:shadow-md transition-shadow"
            >
              <div className="flex justify-between items-start mb-2">
                <span className="bg-emerald-100 text-emerald-800 text-xs font-bold px-2 py-1 rounded-full uppercase tracking-wide">
                  {article.category}
                </span>
                <span className="text-gray-400 text-xs">{article.readTime}</span>
              </div>
              <h3 className="text-lg font-bold text-gray-800">{article.title}</h3>
            </div>
          ))}
        </div>
      </div>

      {/* Reader Modal */}
      {activeArticle && (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/50 backdrop-blur-sm p-4">
          <div className="bg-white w-full max-w-lg rounded-t-3xl sm:rounded-2xl max-h-[90vh] overflow-y-auto flex flex-col shadow-2xl">
            {/* Modal Header */}
            <div className="sticky top-0 bg-white border-b border-gray-100 p-4 flex justify-between items-center z-10">
              <span className="text-xs font-bold text-gray-400 uppercase tracking-widest">
                {activeArticle.category}
              </span>
              <button
                onClick={() => setActiveArticle(null)}
                className="p-2 bg-gray-100 rounded-full hover:bg-gray-200"
              >
                ✕
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 leading-tight">
                {activeArticle.title}
              </h2>
              <div
                className="prose prose-emerald text-gray-600 leading-relaxed space-y-4"
                dangerouslySetInnerHTML={{ __html: activeArticle.content }}
              />

              {/* CTA Button */}
              <div className="mt-8 pt-6 border-t border-gray-100">
                <button
                  onClick={() => {
                    setActiveArticle(null);
                    navigate(activeArticle.ctaLink);
                  }}
                  className="w-full py-4 bg-emerald-600 text-white font-bold rounded-xl shadow-lg hover:bg-emerald-700 active:scale-95 transition-transform flex items-center justify-center gap-2"
                >
                  {activeArticle.ctaText} →
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Bottom Navigation */}
      <BottomNavBar currentPath="/learn" />
    </div>
  );
};

export default LearnTab;
